import React from "react";

const StorySection = () => {
  return (
    <section className="section story-section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">The Problem</p>
        </div>
        <div className="split-grid">
          <div
            className="section-image problem-image"
            aria-label="Professional managing job applications"
          ></div>
          <div>
            <h2>Job searching should not feel like a second job.</h2>
            <p>
              Qualified candidates lose hours to repetitive applications, ATS
              filters, unanswered recruiter messages, and scattered tracking.
            </p>
            <div className="check-grid">
              <span>No replies after dozens of applications</span>
              <span>ATS filters hiding qualified profiles</span>
              <span>Tailored resumes taking too much time</span>
              <span>Ghosting and tracking fatigue</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
